import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85ca71e0")

_pushScopeId("data-v-85ca71e0")
const _hoisted_1 = { class: "white-back-mask" }
const _hoisted_2 = { class: "verification-fail-module" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountManageHeader = _resolveComponent("AccountManageHeader")!
  const _component_VerificationHeader = _resolveComponent("VerificationHeader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AccountManageHeader, { onClose: _ctx.closeModal }, null, 8, ["onClose"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_VerificationHeader, {
          title: "验证不成功",
          description: "验证信息与原绑定不符，无法继续操作"
        })
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          class: "close-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "我知道了")
      ])
    ])
  ]))
})